import { render, staticRenderFns } from "./NewsDetail4.vue?vue&type=template&id=d0cd00a0&scoped=true&"
import script from "./NewsDetail4.vue?vue&type=script&lang=js&"
export * from "./NewsDetail4.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail4.vue?vue&type=style&index=0&id=d0cd00a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd00a0",
  null
  
)

export default component.exports